import { gql } from '@apollo/client';

export const EXPORT_FUNDER_INTERVENTIONS = gql`
  query ExportFunderInterventions($input: ExportArgs) {
    interventions: exportFunderInterventions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          accredited
          accreditation
          class {
            id
            name
          }
          description
          fromDate
          grades {
            id
            value
          }
          id
          impactThemes {
            id
            name
          }
          name
          outcomeThemes {
            id
            name
          }
          phase {
            id
            name
          }
          programme {
            id
            name
          }
          serviceProviders {
            id
            name
          }
          subjects {
            id
            subjectGradeReference
          }
          theoryOfChange
          toDate
          treatmentGroup {
            id
            name
          }
          treatmentGroups {
            id
          }
        }
      }
    }
  }
`;
